import './email-select-control.scss';

import EmailSelectControl from './EmailSelectControl';

export default EmailSelectControl;
